import { useGetPublicOrgInvitationQuery } from '@/queries/organizations.queries';
import tenantDomainService from '@/services/tenant-domain.service';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export function useInvitationTenantDomainRedirect() {
	const { id } = useParams<{ id: string }>();
	const location = useLocation();
	const invitationQuery = useGetPublicOrgInvitationQuery(id);

	const redirectUrl =
		invitationQuery.data && import.meta.env.MODE === 'production'
			? tenantDomainService.getUrlOnTenantDomain(invitationQuery.data.tenantDomain, {
					host: window.location.host,
					pathname: location.pathname,
					search: location.search,
					hash: location.hash,
				})
			: null;

	useEffect(() => {
		if (redirectUrl) {
			tenantDomainService.redirectTo(redirectUrl);
		}
	}, [redirectUrl]);

	return { isLoading: invitationQuery.isPending || redirectUrl !== null };
}
